// Merge extracted variable registries while preserving later declarations.
// Example: loop-generated `--duration-100` overrides an earlier duplicate key.
import type { LuisArrayVariables, LuisCompileWarning, LuisObjectVariables } from '../types'
import type { PreprocessedLuisSource } from './extract-and-expand-loops'

/** @internal Internal preprocess payload used only while merging extracted registries. */
type ExtractedVariablePayload = {
  _variables: Record<string, string>
  _classVariables: Record<string, string>
  _objectVariables: LuisObjectVariables
  _arrayVariables: LuisArrayVariables
  _warnings: LuisCompileWarning[]
}

// Merge one extracted variable payload into the preprocess accumulator.
/** @internal Merge one extracted variable payload into the preprocess accumulator. */
export function mergeExtractedVariables(
  current: Omit<PreprocessedLuisSource, 'source'>,
  next: ExtractedVariablePayload,
): Omit<PreprocessedLuisSource, 'source'> {
  // Return merged registries where later declarations overwrite earlier ones.
  return {
    variables: { ...current.variables, ...next._variables },
    classVariables: { ...current.classVariables, ...next._classVariables },
    objectVariables: { ...current.objectVariables, ...next._objectVariables },
    arrayVariables: { ...current.arrayVariables, ...next._arrayVariables },
    warnings: [...current.warnings, ...next._warnings],
  }
}
